import React from "react";
import { Link } from "react-router-dom";
import logoImage from "../../assets/images/logoNew.jpg";
import UseTitle from "../../Utility/UseTitle/UseTitle";
import Typography from "../../Utility/Typography";
import Button from "../../Utility/Button/Button";
import { ROUTES } from "../../constants";

export default function VerifyEmailSuccess() {
  return (
    <div>
      <UseTitle formattedTitle="Email Verified" />
      <div className="auth-page-wrapper">
        <div className="auth-page-content pb-0">
          <div className="w-full max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-center h-screen">
              <div className="w-full md:w-2/3 lg:w-1/2 xl:w-2/5">
                <div className="bg-surface-primary rounded-md border border-border-primary shadow-sm mt-4">
                  <div className="mt-5">
                    <div className="flex justify-center items-center">
                      <img
                        src={logoImage}
                        alt="Logo"
                        className="h-[72px] w-auto max-w-[280px] object-contain"
                      />
                    </div>
                  </div>
                  <div className="p-4 mt-4">
                    <div className="p-2 text-center">
                      <div className="flex justify-center mb-4">
                        <div className="w-16 h-16 rounded-full bg-badge-success/20 flex items-center justify-center">
                          <i className="ri-check-line text-4xl text-badge-success" />
                        </div>
                      </div>
                      <Typography variant="h4" className="mb-4 text-theme-primary">
                        Verify Email Successfully
                      </Typography>
                      <Typography variant="text2" className="mb-6 text-text-secondary">
                        Your email has been verified successfully. You can now sign in to your
                        account.
                      </Typography>
                      <div className="mt-4">
                        <Link to={ROUTES.LOGIN}>
                          <Button
                            type="button"
                            variant="primary"
                            className="w-full flex items-center justify-center gap-2"
                          >
                            <Typography variant="text2" component="span">
                              Back to Login
                            </Typography>
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
